import Alert from 'react-bootstrap/Alert';
import styled from 'styled-components';

//Aletrta principal del formulario en caso de que un  campose se erroneo
const ErrorForm = ({ mensaje, estadoAlerta, cambiarEstadoAlerta }) => {
    return (
        <>
            {estadoAlerta &&
                <Alert variant="danger">
                    {mensaje}
                </Alert>
            }

        </>

    );
}


const AlertBusqueda = ({ mensaje, estadoAlerta }) => {
    return (
        <>
            {estadoAlerta &&
                <EstiloAlerta variant="secondary"  >
                    <Alert.Heading>No se encuentra el curso</Alert.Heading>
                    <p>{mensaje}</p>
                </EstiloAlerta>
            }
        </>
    );

}

const EstiloAlerta = styled(Alert)`
    
    margin-top: 2% !important;

    @media (max-width: 576px) {
        font-size: 14px;
        width: 90% !important;
        height: 80% !important;
        margin-left: 5%;
    }
`;




export { ErrorForm, AlertBusqueda };


